import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Pillars from './components/Pillars';
import Trending from './components/Trending';
import About from './components/About';
import Menu from './components/Menu';
import Location from './components/Location';
import Community from './components/Community';
import Footer from './components/Footer';
import AffiliateModal from './components/AffiliateModal';
import GalleryModal from './components/GalleryModal';
import CollaboratorsModal from './components/CollaboratorsModal';
import { ChopstickDivider } from './components/decor';
import { Toaster } from './components/ui/toaster';

import OrderPage from './pages/OrderPage';
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import OrderSuccess from './pages/OrderSuccess';
import OrderTracking from './pages/OrderTracking';
import MyOrders from './pages/MyOrders';
import AdminDashboard from './pages/AdminDashboard';
import DriverPortal from './pages/DriverPortal';

// Import Google Fonts
import './styles/fonts.css';

const Home = ({ onOpenGallery, onOpenAffiliate, onOpenCollaborators }) => {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0A' }}>
      <Header
        onOpenGallery={onOpenGallery}
        onOpenAffiliate={onOpenAffiliate}
        onOpenCollaborators={onOpenCollaborators}
      />
      <main>
        <Hero />
        <ChopstickDivider />
        <Pillars />
        <ChopstickDivider />
        <Trending />
        <Menu />
        <ChopstickDivider />
        <About onOpenGallery={onOpenGallery} />
        <Location />
        <Community
          onOpenGallery={onOpenGallery}
          onOpenAffiliate={onOpenAffiliate}
          onOpenCollaborators={onOpenCollaborators}
        />
      </main>
      <Footer
        onOpenGallery={onOpenGallery}
        onOpenAffiliate={onOpenAffiliate}
        onOpenCollaborators={onOpenCollaborators}
      />
      <Toaster />
    </div>
  );
};

const DriverGuard = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user && user.role === 'driver' && location.pathname !== '/chofer') {
    return <Navigate to="/chofer" replace />;
  }
  return children;
};

function App() {
  const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);
  const [isAffiliateModalOpen, setIsAffiliateModalOpen] = useState(false);
  const [isCollaboratorsModalOpen, setIsCollaboratorsModalOpen] = useState(false);

  const openGalleryModal = () => setIsGalleryModalOpen(true);
  const closeGalleryModal = () => setIsGalleryModalOpen(false);

  const openAffiliateModal = () => setIsAffiliateModalOpen(true);
  const closeAffiliateModal = () => setIsAffiliateModalOpen(false);

  const openCollaboratorsModal = () => setIsCollaboratorsModalOpen(true);
  const closeCollaboratorsModal = () => setIsCollaboratorsModalOpen(false);

  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <DriverGuard>
            <Routes>
              <Route path="/" element={
                <Home
                  onOpenGallery={openGalleryModal}
                  onOpenAffiliate={openAffiliateModal}
                  onOpenCollaborators={openCollaboratorsModal}
                />
              } />
              <Route path="/pedir" element={<OrderPage />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/pedido/:id" element={<OrderTracking />} />
              <Route path="/mis-pedidos" element={<MyOrders />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/chofer" element={<DriverPortal />} />
            </Routes>
            </DriverGuard>

            {/* Home Modals */}
            <GalleryModal isOpen={isGalleryModalOpen} onClose={closeGalleryModal} />
            <AffiliateModal isOpen={isAffiliateModalOpen} onClose={closeAffiliateModal} />
            <CollaboratorsModal open={isCollaboratorsModalOpen} onClose={closeCollaboratorsModal} />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
